/* eslint-disable no-console */
const isDev = process.env.NODE_ENV !== 'production'

export function debugLog(error, context = '') {
  if (isDev) {
    console.error(`[${context}]`, error)
  }
  // TODO AD-17: brancher Sentry/Datadog ici
  // Sentry.captureException(error, { tags: { context } })
}
